import React, { Component } from 'react';
import './App.css';


class PhilipsHue extends Component {
    constructor(props){
      super(props);
    }
    render() {
      document.title = 'Home'
      return (
        <div className="-component">
          <div className="-container">
          <p className="jack-paragraph">
            Turn on and dim lights
          </p>
          <div className="jack-container-blocks">
            <div className="jack-block">
              Kitchen: 
              <span className="jack-totals-span"><button>Toggle</button></span>
            </div>
            <div className="jack-block">
              Bedroom: 
              <span className="jack-totals-span"><button>Toggle</button></span>
            </div>
            <div className="jack-block">
              Den: 
              <span className="jack-totals-span"><button>Toggle</button></span>
            </div>
            <div className="jack-block income-green">
              Gym: 
              <span className="jack-totals-span"><button>Toggle</button></span>
            </div>
            <div className="jack-block">
              Office: 
              <span className="jack-totals-span"><button>Toggle</button></span>
            </div>
          </div>
          </div>
        </div>
      );
    }
  }
  
  export default PhilipsHue;
  